import React from "react";

import { Box, Typography } from "@material-ui/core";

export default function Error() {
  return (
    <Box textAlign="center">
      <Typography variant="h1">404</Typography>
      <Typography variant="subtitle1">Page not found</Typography>
    </Box>
  );
}
